import { Input } from "rizzui";
import { PiMagnifyingGlassBold } from "react-icons/pi";

export default function FilterElement({
  onSearch,
  searchTerm,
}: {
  onSearch: (searchTerm: string) => void;
  searchTerm: string;

  updateFilter: (key: string, value: any) => void;
  variant?: string;
}) {
  function clearSearch() {
    onSearch("");
  }

  return (
    <div className="flex flex-wrap items-center justify-between gap-3 lg:flex-nowrap mb-3">
      <div className="flex w-full items-center gap-3 md:w-auto">
        <Input
          type="search"
          placeholder="Search by name..."
          value={searchTerm}
          onClear={clearSearch}
          onChange={(e) => onSearch(e.target.value)}
          clearable={true}
          prefix={<PiMagnifyingGlassBold className="h-4 w-4" />}
          className="w-full"
        />
      </div>
    </div>
  );
}
